import React from "react";
import { adminApi } from "@/lib/api";
import LiveChatConsole from "@/components/LiveChatConsole";

export default function LiveChats() {
    return (
        <div className="h-screen" data-testid="page-live-chats">
            <LiveChatConsole api={adminApi} />
        </div>
    );
}
